import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component RecurringIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <RecurringIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <RecurringIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const RecurringIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 18 18"
      data-testid="RecurringIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="m15.364 2.636.225.233.214.238a8.86 8.86 0 0 1 2.04 4.216l.043.25q.107.662.114 1.332h-.007l.001.095h-2.008a6.95 6.95 0 0 0-1.43-4.26l-.095-.12a7 7 0 0 0-10.238-.738l-.173.168 1.414 1.414-4.872.63.63-4.872 1.414 1.414A8.98 8.98 0 0 1 9.361.007c2.1.084 4.175.898 5.813 2.444zM2.636 15.364a8.9 8.9 0 0 1-2.498-4.789A9 9 0 0 1 0 9.01h.006V9h2.008a6.94 6.94 0 0 0 1.826 4.73l.21.22a7 7 0 0 0 9.727.167l.173-.167-1.414-1.414 4.871-.63-.629 4.872-1.414-1.414a9 9 0 0 1-12.728 0"
        clipRule="evenodd"
      />
    </svg>
  )
);
RecurringIcon.displayName = "RecurringIcon";
export default RecurringIcon;
